import AgricultureConditions from '@/assets/custom-icons/agricultureConditions.vue';
import AgricultureDemand from '@/assets/custom-icons/agricultureDemand.vue';
import Book from '@/assets/custom-icons/book.vue';
import Bookmark from '@/assets/custom-icons/bookmark.vue';
import Checkmark from '@/assets/custom-icons/checkmark.vue';
import Climate from '@/assets/custom-icons/climate.vue';
import ClipBoard from '@/assets/custom-icons/clipboard.vue';
import CloudSun from '@/assets/custom-icons/cloudSun.vue';
import Compass from '@/assets/custom-icons/compass.vue';
import Cog from '@/assets/custom-icons/cog.vue';
import Crop from '@/assets/custom-icons/crop.vue';
import CropHalf from '@/assets/custom-icons/cropHalf.vue';
import CropFilled from '@/assets/custom-icons/cropFilled.vue';
import Data from '@/assets/custom-icons/data.vue';
import DoubleDash from '@/assets/custom-icons/doubleDash.vue';
import Drop from '@/assets/custom-icons/drop.vue';
import DropFilled from '@/assets/custom-icons/dropFilled.vue';
import DropHalf from '@/assets/custom-icons/dropHalf.vue';
import Evaporation from '@/assets/custom-icons/evaporation.vue';
import Flag from '@/assets/custom-icons/flag.vue';
import House from '@/assets/custom-icons/house.vue';
import HouseOutline from '@/assets/custom-icons/houseOutline.vue';
import JusticeScales from '@/assets/custom-icons/justiceScales.vue';
import Leaf from '@/assets/custom-icons/leaf.vue';
import LeafFilled from '@/assets/custom-icons/leafFilled.vue';
import LeafHalfFilled from '@/assets/custom-icons/leafHalfFilled.vue';
import LegendCircle from '@/assets/custom-icons/legend-circle.vue';
import LegendCircleSmall from '@/assets/custom-icons/legend-circle-small.vue';
import LegendLine from '@/assets/custom-icons/legend-line.vue';
import LegendPie from '@/assets/custom-icons/legend-pie.vue';
import LightBulb from '@/assets/custom-icons/light-bulb.vue';
import Lightning from '@/assets/custom-icons/lightning.vue';
import Map from '@/assets/custom-icons/map.vue';
import OilBarrel from '@/assets/custom-icons/oilBarrel.vue';
import Person from '@/assets/custom-icons/person.vue';
import PersonFilled from '@/assets/custom-icons/personFilled.vue';
import PersonHalf from '@/assets/custom-icons/personHalf.vue';
import PlayButton from '@/assets/custom-icons/playbutton.vue';
import RadioAltOff from '@/assets/custom-icons/radioAltOff.vue';
import RadioAltOn from '@/assets/custom-icons/radioAltOn.vue';
import Tree from '@/assets/custom-icons/tree.vue';
import User from '@/assets/custom-icons/user.vue';
import WaterGlass from '@/assets/custom-icons/waterGlass.vue';
import WaterGlassFilled from '@/assets/custom-icons/waterGlassFilled.vue';
import WaterGlassHalf from '@/assets/custom-icons/waterGlassHalf.vue';
import WaterRefresh from '@/assets/custom-icons/waterRefresh.vue';
import WaterTap from '@/assets/custom-icons/waterTap.vue';

const customIcons = {
  values: {
    AgricultureConditions: {
      component: AgricultureConditions,
    },
    AgricultureDemand: {
      component: AgricultureDemand,
    },
    Book: {
      component: Book,
    },
    Bookmark: {
      component: Bookmark,
    },
    Checkmark: {
      component: Checkmark,
    },
    Climate: {
      component: Climate,
    },
    ClipBoard: {
      component: ClipBoard,
    },
    CloudSun: {
      component: CloudSun,
    },
    Compass: {
      component: Compass,
    },
    Cog: {
      component: Cog,
    },
    Crop: {
      component: Crop,
    },
    CropFilled: {
      component: CropFilled,
    },
    CropHalf: {
      component: CropHalf,
    },
    Data: {
      component: Data,
    },
    Drop: {
      component: Drop,
    },
    DropFilled: {
      component: DropFilled,
    },
    DropHalf: {
      component: DropHalf,
    },
    DoubleDash: {
      component: DoubleDash,
    },
    Evaporation: {
      component: Evaporation,
    },
    Flag: {
      component: Flag,
    },
    House: {
      component: House,
    },
    HouseOutline: {
      component: HouseOutline,
    },
    JusticeScales: {
      component: JusticeScales,
    },
    LightBulb: {
      component: LightBulb,
    },
    Leaf: {
      component: Leaf,
    },
    LeafFilled: {
      component: LeafFilled,
    },
    LeafHalf: {
      component: LeafHalfFilled,
    },
    LegendCircle: {
      component: LegendCircle,
    },
    LegendCircleSmall: {
      component: LegendCircleSmall,
    },
    LegendLine: {
      component: LegendLine,
    },
    LegendPie: {
      component: LegendPie,
    },
    Lightning: {
      component: Lightning,
    },
    Map: {
      component: Map,
    },
    OilBarrel: {
      component: OilBarrel,
    },
    PlayButton: {
      component: PlayButton,
    },
    Person: {
      component: Person,
    },
    PersonFilled: {
      component: PersonFilled,
    },
    PersonHalf: {
      component: PersonHalf,
    },
    RadioAltOff: {
      component: RadioAltOff,
    },
    RadioAltOn: {
      component: RadioAltOn,
    },
    Tree: {
      component: Tree,
    },
    User: {
      component: User,
    },
    WaterGlass: {
      component: WaterGlass,
    },
    WaterGlassFilled: {
      component: WaterGlassFilled,
    },
    WaterGlassHalf: {
      component: WaterGlassHalf,
    },
    WaterRefresh: {
      component: WaterRefresh,
    },
    WaterTap: {
      component: WaterTap,
    },
  },
};

export default customIcons;
